<!-- ********************  DATA LISTs ******************  -->

<section>

  <datalist id="listCentroCustos">
    <select>
      <option *ngFor="let item of centrosDeCusto" [value]="item.nome"></option>
    </select>
  </datalist>


</section>


<div class="row">
  <div class="col">
    <div class="main-card mb-3 card">
      <div class="card-body">

        <form novalidate [formGroup]="form" id="form" (ngSubmit)="submit()">

          <input class="form-control text-center" formControlName="id" type="text" hidden>

          <div class="form-row">
            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="id">Nº</label>
                <input class="form-control text-center" type="text"
                  value="{{ form?.controls['id'].value | zerosEsquerda : 5 }}" disabled readonly>
              </div>
            </div>

            <div class="col-md-4">
              <div class="position-relative form-group">
                <label for="requisitante">Requisitante<span class="field-required">(*)</span></label>
                <input class="form-control" formControlName="requisitante" type="text" maxlength="20" value="" required
                  id="requisitante">
              </div>
            </div>
            <div class="col-md-2">
              <div class="position-relative form-group">
                <label for="contato">Ramal<span *ngIf="this.requeridoRamalCentroCusto"
                  class="field-required">(*)</span></label>
                <input class="form-control" digitOnly formControlName="contato" type="text" maxlength="7" value="" (change)="changeRamal($event.target.value)"
                [ngClass]="{'h-error' : !this.contatoValid}"
                >
                <small *ngIf="!this.contatoValid" class="form-text text-danger pl-2">
                  O valor deve ser informado
                  </small>
              </div>
            </div>

            <div class="col-md-4">


              <div class="form-group">
                <label for="centroDeCusto">{{labelCentroCusto}}<span *ngIf="this.requeridoRamalCentroCusto"
                  class="field-required">(*)</span></label>

                <div class="input-group">
                  <input type="text" class="form-control" list="listCentroCustos" formControlName="datalistCentroCustos" (change)="changeCentroCusto($event.target.value)"
                    (change)="changeDataListCentroCustos($event.target.value)" maxlength="40" 
                    [ngClass]="{'h-error' : !this.centroCustoValid}"
                    />
                  <div class="input-group-append cp" (click)="limparDataListCentroCustos()"
                    title="limpar campo e recarregar lista de opções">
                    <span class="input-group-text"><i class="fa fa-trash"></i></span>
                  </div>
                  
                </div>
                <small *ngIf="!this.centroCustoValid" class="form-text text-danger pl-2">
                  O valor deve ser informado
                  </small>
              </div>


              <!--- -----------------**** ----------------- -->



            </div>
            <!--   </div>
            </div> -->

          </div>

          <div class="form-row">

            <div class="col">
              <div class="position-relative form-group">
                <label for="servico">Serviço Solicitado <span class="field-required">(*)</span></label>
                <textarea rows="8" class="form-control text-uppercase" formControlName="servico" value=""
                  maxlength="300" required style="resize: none;"></textarea>
              </div>
            </div>
          </div>



          <!-- 1 -->
          <div class="form-row" style="border-top: solid 3px #ccc; padding-top: 25px;">


            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="">Grupo local</label>
                <select for="" class="form-control" formControlName="grupoLocalNivel1Id"
                  (change)="changeGrupoLocalNivel1()">
                  <option value="">selecione</option>
                  <option *ngFor="let t of this.niveis1" [value]="t.id">{{ t.nome }}</option>
                </select>
              </div>
            </div>

            <div class=" col-md-6">
              <div class="position-relative form-group">
                <label for="">Local de Trabalho <span class="field-required">(*)</span></label>

                <select class="form-control" #localId formControlName="localId"
                  (change)="getEquipamentoPorLocalId(localId.value)"
                  [ngClass]="{'h-error': form.get('localId').hasError('invalidLocalId')}">
                  <option value="">selecione</option>
                  <option *ngFor="let l of locaisPorNivel" [value]="l.id">{{ l.nome }}</option>
                </select>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('localId').hasError('invalidLocalId')">O Local deve ser informado</small>
                </section>
              </div>
            </div>


          </div>




          <!-- 2 -->
          <div class="form-row">


            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="equipamentoId">Equipamento
                  <span *ngIf="buscandoEquipamentos" class="ball-clip-rotate">
                    <div></div>
                  </span>
                </label>

                <div class="input-group">
                  <select class="form-control" formControlName="equipamentoId">
                    <option value="">selecione</option>
                    <option *ngFor="let e of equipamentos" value="{{ e.id }}">{{ e.nome }}</option>
                  </select>
                  <div class="input-group-append cp">
                    <span class="input-group-text"
                      (click)="openModalCadastroEquipamento(localId.value, modalequipamento)"
                      title="Cadastro Equipamento"><i class="fa fa-plus-circle"></i></span>
                  </div>

                </div>
              </div>
            </div>


            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="">Prioridade <span class="field-required">(*)</span></label>
                <select class="form-control" #prioridade formControlName="prioridadeId">
                  <option value="" selected>selecione</option>
                  <option *ngFor="let p of prioridades" [value]="p.id">{{p.descricao}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="">Tipo de OS<span class="field-required">(*)</span></label>
                <select class="form-control" formControlName="tipoOS" value="">
                  <option *ngFor="let op of this.tipoOSFixas" [value]="op.codigo">{{op.descricao}}</option>
                  <option *ngFor="let op of this.tipoOSAdicionais" [value]="op.codigo">{{op.descricao}}</option>
                </select>
              </div>
            </div>



          </div>
          <!-- 3 -->
          <div class="form-row">


          </div>




          <!-- 4 -->
          <div class="form-row">


            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="id">Área Técnica <span class="field-required">(*)</span></label>
                <div class="input-group">

                  <select class="form-control" #areaTecnicaId formControlName="areaTecnicaId" value="">
                    <option value="" selected>selecione</option>
                    <option *ngFor="let at of areasTecnicas" value="{{ at.id }}">{{ at.nome }}</option>
                  </select>

                  <div class="input-group-append cp" (click)="openModalNovaAreaTecnica(modaloutraareatecnica)"
                    title="Cadastrar outro Área Técnica">
                    <span class="input-group-text"><i class="fa fa-plus-circle"></i></span>
                  </div>
                </div>
              </div>
            </div>



            <div class="col-md-6">


              <div class="position-relative form-group">
                <div style="margin-top: 40px; margin-left: 15px;">
                  <span mr-2 pl-2>Área de Risco<span class="field-required">(*)</span></span>
                  <input formControlName="areaRestrita" name="areaRestrita" type="radio" [value]="true"
                    style="height: 15px; width: 15px;" class="ml-3"><span class="pl-1 pr-3 pt-5">Sim</span>
                  <input formControlName="areaRestrita" name="areaRestrita" type="radio" [value]="false"
                    style="height: 15px; width: 15px;"><span class="pl-1 pr-3">Não</span>
                </div>
              </div>


            </div>



          </div>



          <div class="form-row">

            <div class="col-md-4" *ngIf="this.empreiteiras.length >  1">
              <div class="position-relative form-group">
                <label for="empreiteiraId">Empreiteira</label>
                <select class="form-control" #empreiteiraId formControlName="empreiteiraId" required
                  (change)="changeEmpreiteira(empreiteiraId.value)">
                  <option *ngFor="let e of this.empreiteiras" value="{{ e.id }}">{{ e.nome }}</option>
                </select>
              </div>
            </div>



          </div>






        </form>



        <form novalidate [formGroup]="photoForm" class="row">
          <input hidden #fileInput formControlName="photo" type="file" accept="image/*" multiple
            (change)="handleFile($event.target.files)">
        </form>

        <section style="border: 1px solid #ddd;" *ngIf="this.autorizacaoAdicionarFoto">
          <div class="form-row text-center" style="padding: 0 5px;">
            <div class="col-md-11 fb fs11" style="background-color: #eee; padding: 12px">
              <i *ngIf="this.isLoadingRegistroFotografico" class="fa fa-spinner fa-spin fa-fw pull-left"></i>
              Registro fotográfico
            </div>
            <div class="col-md-1 bg-primary cp" style="padding: 12px" title="Adicionar Registro Fotográfico"
              (click)="fileInput.click()">
              <span><i class="fwn fa fa-plus"></i></span>
            </div>

          </div>

          <div class="row showImagens" style="padding-bottom: 20px; min-height: 150px;">
            <div class="col-md-2" *ngFor="let pview of previewsPhotos">
              <div>
                <img [src]="pview.dataUrl" class="zoom cp" (click)="openModalExibePhoto(modalExibePhoto, pview)">
                <button type="button" class="btn btn-default">
                  <i class="fa fa-trash text-secoundary" (click)="removerPhoto(pview.name)"
                    title="Remover esta foto"></i>
                </button>
              </div>
            </div>
          </div>

        </section>



      </div>
    </div>
  </div>
</div>



<div class="row">
  <div class="col-md-12">
    <div class="box box-primary box-dark">

      <div class="box-body">

        <div class="row">

          <div class="col-md-4">
          </div>

          <div class="col-md-4 mb-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq-dark.png" /></a>
            </div>
          </div>

          <div class="col-md-2">
            <button class="btn btn-block btn-outline-primary dark-outline btn-shadow btn-block" type="button"
              (click)="reset()">
              <i class="fa pull-left fa-trash"></i>Limpar
            </button>
          </div>

          <div class="col-md-2">
            <button type="submit" class="btn btn-block btn-shadow" form="form"
              [disabled]="(!(this.isNovoCadastro && this.autorizacoes?.podeIncluir) && !(!this.isNovoCadastro && this.autorizacoes?.podeAlterar)) || this.isSalvando"
              [ngClass]="{ 'btn-primary dark' : isNovoCadastro, 'btn-warning' : !isNovoCadastro }" type="submit">
              <i class="fa mr-3" [ngClass]="{'fa-plus' : isNovoCadastro, 'fa-edit' : !isNovoCadastro}"></i>
              {{ isNovoCadastro ? 'Cadastrar' : 'Editar' }} <i class="mr-2">&nbsp;</i>
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>



</div>














<!-- MODAIS -->




<ng-template #modaloutraareatecnica let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Cadastro Outra Área Técnica</h4>
  </div>
  <div class="modal-body">
    <form novalidate [formGroup]="formAreaTecnica" id="formAreaTecnica" (validSubmit)="novaAreaTecnica(c)">

      <div class="form-row">
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Nome</label>
            <input class="form-control" type="text" formControlName="nome" maxlength="20" />
            <section *ngIf="!formAreaTecnica.valid" class="form-text text-danger pl-2">
              <small *ngIf="formAreaTecnica.get('nome').hasError('notUnique')">Nome de Área Técnica já
                utilizado</small>
            </section>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">

    <div class="col-md-2"></div>
    <div class="col-md-4">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Cancelar</button>
    </div>

    <div class="col-md-6">
      <button type="submit" class="btn btn-primary btn-block btn-shadow" form="formAreaTecnica">
        <i class="fa fa-plus pull-left pt-1"></i>Cadastrar
      </button>
    </div>
  </div>

</ng-template>


<!-- CADASTRO EQUIPAMENTO -->

<ng-template #modalequipamento let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Cadastro Equipamento</h4>
  </div>

  <div class="modal-body">


    <form novalidate [formGroup]="formEquipamento" id="formEquipamento" (validSubmit)="addEquipamento(c)">

      <!--  Campos ocultos e disables -->
      <select class="form-control" formControlName="localId" hidden>
        <option *ngFor="let l of locaisPorNivel" [value]="l.id">{{ l.nome }}</option>
      </select>
      <!--  /Campos ocultos e disables -->

      <div class="form-row">
        <div class="col-md-4">
          <div class="position-relative form-group">
            <label for="">Nome</label>
            <input class="form-control" type="text" formControlName="nome" maxlength="120" />
            <section *ngIf="!formEquipamento.valid" class="form-text text-danger pl-2">
              <small *ngIf="formEquipamento.get('nome').hasError('notUnique')">Nome de equipamento já
                utilizado</small>
            </section>
          </div>
        </div>
        <div class="col-md-8">
          <div class="position-relative form-group">
            <label for="">Nº de série</label>
            <input class="form-control" type="text" maxlength="15" formControlName="numeroSerie" />
            <section *ngIf="!formEquipamento.valid" class="form-text text-danger pl-2">
              <small *ngIf="formEquipamento.get('numeroSerie').hasError('notUniquens')">Nº de série já
                utilizado</small>
            </section>
          </div>
        </div>
      </div>


      <div class="form-row">
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Descrição</label>
            <textarea row="2" class="form-control" type="text" formControlName="descricao" maxlength="40"></textarea>
          </div>
        </div>
      </div>

      <div class="form-row">
    
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Local de Trabalho</label>
            <select class="form-control" [value]="this.formEquipamento.get('localId').value" disabled>
              <option *ngFor="let l of locaisPorNivel" [value]="l.id">{{ l.nome }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="form-row">

        <div class="col-md-4">
          <div class="position-relative form-group">
            <label for="">Classe equipamento<span class="field-required">(*)</span></label>
            <select for="" class="form-control" formControlName="classeEquipamentoId" required>
              <option value="">selecione</option>
              <option *ngFor="let t of this.classesEquipamento" [value]="t.id">{{ t.descricao }}</option>
            </select>
          </div>
        </div>

        <div class="col-md-8">
          <div class="position-relative form-group">
            <label for="">Fabricante <span class="field-required">(*)</span></label>
            <div class="input-group">
              <div class="input-group">

                <select class="form-control" formControlName="fabricanteId">
                  <option *ngFor="let l of fabricantes" value="{{ l.id }}">{{ l.nome }}</option>
                </select>


                <div class="input-group-append cp" (click)="openModalCadastroFabricante(modalfabricante)"
                  title="Cadastro Fabricante">
                  <span class="input-group-text"><i class="fa fa-plus-circle"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <div class="col-md-4"></div>

    <div class="col-md-4">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Cancelar</button>
    </div>
    <div class="col-md-4">
      <button type="submit" class="btn btn-primary btn-block btn-shadow" form="formEquipamento">
        <i class="fa fa-plus pull-left pt-1"></i>Cadastrar
      </button>
    </div>
  </div>

</ng-template>



<!-- CADASTRO FABRICANTE -->

<ng-template #modalfabricante let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h4 class="modal-title">Cadastro Fabricante</h4>
  </div>

  <div class="modal-body">


    <form novalidate [formGroup]="formFabricante" id="formFabricante" (validSubmit)="addFabricante(c)">

      <div class="form-row">
        <div class="col-md-12">
          <div class="position-relative form-group">
            <label for="">Nome</label>
            <input class="form-control" type="text" formControlName="nome" maxlength="50" />
            <section *ngIf="!formFabricante.valid" class="form-text text-danger pl-2">
              <small *ngIf="formFabricante.get('nome').hasError('notUnique')">Nome de fabricante já
                utilizado</small>
            </section>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">

    <div class="col-md-2"></div>
    <div class="col-md-4">
      <button type="button" class="btn btn-secondary btn-block" (click)="c('Close click')">Cancelar</button>
    </div>
    <div class="col-md-6">
      <button type="submit" class="btn btn-primary btn-block btn-shadow" form="formFabricante">
        <i class="fa fa-plus pull-left pt-1"></i>Cadastrar
      </button>
    </div>
  </div>

</ng-template>


<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518;">
    <div class="row">
      <div class="col-md-12 text-center" style="padding:10px; background: #141518 ;">
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding:10px; background: #141518 ;">
      <div class="text-right">
        <button type="button" class="btn btn-secondary pl-5 pr-5 mr-4" (click)="c('Close click')">Fechar</button>
      </div>
    </div>
  </div>
</ng-template>